import { Text } from "@chakra-ui/react";
import React from "react";
import { OrganizationDateView } from "src/components/DataDisplay/OrganizationDateView";
import { LearnMore } from "src/components/Links/LearnMore";
import { useRemoteDataQuery } from "src/hooks/useRemoteDataQuery";
import * as format from "src/services/format";
import * as GQL from "src/types/graphql";
import { GET_MATCH_PUBLISH_EVENT } from "../graphql/queries";

type Props = {
  matchId: string;
};
export const PublishInfo: React.FC<Props> = ({ matchId }) => {
  const { remoteData } = useRemoteDataQuery<
    GQL.GetMatchPublishEvents,
    GQL.GetMatchPublishEventsVariables
  >(GET_MATCH_PUBLISH_EVENT, {
    variables: {
      matchId,
    },
  });

  const publishEvent = remoteData.toNullable()?.match_run_publish_event[0];

  return (
    <Text color="blackAlpha.700" fontSize="sm">
      {publishEvent && (
        <>
          Last saved on{" "}
          <OrganizationDateView isoDate={publishEvent.published_at} /> by{" "}
          {format.adminName(publishEvent.published_by_person, "Avela admin")}.{" "}
        </>
      )}
      <LearnMore article="44716648319245-Saving-lottery-positions" />.
    </Text>
  );
};
